export default __webpack_public_path__ + "static/faiz2017-1fec55303eb758f6331b745f862fa733.jpg";